module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emiDate),
      expression: "emiDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('emiDate'),
    },
    attrs: {
      "type": "date",
      "name": "emiDate",
      "required": ""
    },
    domProps: {
      "value": (_vm.emiDate)
    },
    on: {
      "change": _vm.loadAgentMemberByDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emiDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "emiDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Payment Status ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('status'),
    },
    attrs: {
      "name": "status"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.loadAgentMember]
    }
  }, [(!_vm.status) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                      Select Status\n                    ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "paid"
    }
  }, [_vm._v("Paid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unpaid"
    }
  }, [_vm._v("Unpaid")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": _vm.getBranchRecord
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Group")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.collectionCenters,
      "placeholder": "Select Group",
      "required": ""
    },
    on: {
      "input": _vm.loadAgentMember
    },
    model: {
      value: (_vm.colC),
      callback: function($$v) {
        _vm.colC = $$v
      },
      expression: "colC"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), (_vm.colC.name) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('br'), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.printView
    }
  }, [_vm._v("Get Print")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('strong', [_vm._v("Total Current Due : " + _vm._s(_vm.totalAmt))])]), _vm._v(" "), _c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Member List")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body table-sm"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columnsAgentMemberRecords,
      "rows": _vm.rowsAgentMemberRecords,
      "styleClass": "vgt-table condensed",
      "line-numbers": true,
      "pagination-options": {
        enabled: true,
        perPage: 10,
        perPageDropdown: [10, 20, 30],
      },
      "search-options": {
        enabled: true,
        trigger: 'enter',
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'EmiDate') ? _c('span', [_vm._v("\n                      " + _vm._s(_vm._f("myDate")(props.row.emiDate)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'Status') ? _c('span', [(props.row.status == 'pending') ? _c('span', {
          staticClass: "label label-warning"
        }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (props.row.status == 'paid') ? _c('span', {
          staticClass: "label label-success"
        }, [_vm._v("Paid")]) : _vm._e(), _vm._v(" "), (props.row.status == 'partial') ? _c('span', {
          staticClass: "label label-info"
        }, [_vm._v("Partial")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (props.column.field == 'action') ? _c('span', [(props.row.arrear > 0 && props.row.member_collection_pending.length <= 0) ? _c('button', {
          staticClass: "btn btn-success btn-xs",
          on: {
            "click": function($event) {
              return _vm.newModal(props.row)
            }
          }
        }, [_vm._v("Collect Payment\n                      ")]) : (props.row.member_collection_pending.length > 0) ? _c('div', {
          staticClass: "text-warning"
        }, [_vm._v("Pending")]) : _c('div', {
          staticClass: "text-success"
        }, [_vm._v("Paid")])]) : _c('span', [_vm._v("\n                      " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body table-sm"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columnsMemberCollections,
      "rows": _vm.rowsMemberCollections,
      "styleClass": "vgt-table condensed",
      "pagination-options": {
        enabled: true,
        perPage: 10,
        perPageDropdown: [10, 20, 30],
      },
      "search-options": {
        enabled: true,
        trigger: 'enter',
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'Status') ? _c('span', [(props.row.status == 'pending') ? _c('span', {
          staticClass: "label label-warning"
        }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (props.row.status == 'paid') ? _c('span', {
          staticClass: "label label-success"
        }, [_vm._v("Paid")]) : _vm._e(), _vm._v(" "), (props.row.status == 'partial') ? _c('span', {
          staticClass: "label label-info"
        }, [_vm._v("Partial")]) : _vm._e()]) : _c('span', [_vm._v("\n                      " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(2), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Payment Collection")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.collectPayment()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('amt')
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('paymentDate'),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.attendance),
      expression: "form.attendance"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('attendance'),
    },
    attrs: {
      "name": "attendance"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "attendance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "present"
    }
  }, [_vm._v("Present")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "absent"
    }
  }, [_vm._v("Absent")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "attendance"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Remark ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.remark),
      expression: "form.remark"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('remark')
    },
    attrs: {
      "type": "text",
      "name": "remark"
    },
    domProps: {
      "value": (_vm.form.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "remark"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.memberloanplan.member) ? _c('div', {
    staticClass: "box box-default"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid img-circle",
    attrs: {
      "src": this.photo,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "callout callout-info"
  }, [_c('h4', [_vm._v("Member")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.memberloanplan.member.name))]), _vm._v(" "), _c('h4', [_vm._v("Mobile No")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.memberloanplan.member.mobile))]), _vm._v(" "), _c('h4', [_vm._v("Address")]), _vm._v(" "), (_vm.memberRecord) ? _c('p', [_vm._v(_vm._s(_vm.memberRecord.address))]) : _vm._e()]), _vm._v(" "), (_vm.memberloanplan.collection_center) ? _c('div', {
    staticClass: "callout callout-danger"
  }, [_c('h4', [_vm._v("Group")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.memberloanplan.collection_center.name))])]) : _vm._e()])]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(7)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "printView"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(8), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printAgentCollectionList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printAgentCollectionList"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', [_c('strong', [_vm._v("Group Detail")]), _vm._v(" "), _c('br'), _vm._v("Name - " + _vm._s(_vm.colC.name)), _c('br'), _vm._v(" \n                          Address: " + _vm._s(_vm.colC.address)), _c('br'), _vm._v("\n                          branch: " + _vm._s(_vm.branch.name) + "\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [(_vm.$store.state.settingRecord) ? _c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$store.state.settingRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.$store.state.settingRecord.address) + ", " + _vm._s(_vm.$store.state.settingRecord.city) + ", " + _vm._s(_vm.$store.state.settingRecord.state) + " - " + _vm._s(_vm.$store.state.settingRecord.pin) + "\n                          "), _c('br'), _vm._v(" Website - " + _vm._s(_vm.$store.state.settingRecord.url) + "\n                          ")])]) : _vm._e()])])]), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Customer EMI Records ")]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_c('strong', [_vm._v("Total Amount : " + _vm._s(_vm.totalAmt))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed"
  }, [_vm._m(9), _vm._v(" "), (_vm.rowsAgentMemberRecords) ? _c('tbody', {
    staticStyle: {
      "border-width": "2px",
      "color": "black",
      "border-style": "solid"
    }
  }, _vm._l((_vm.rowsAgentMemberRecords), function(rowsAgentMemberRecord, index) {
    return _c('tr', {
      key: rowsAgentMemberRecord.id,
      staticStyle: {
        "border-width": "2px",
        "border-style": "solid"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord.member) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.member.code))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord.member) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.member.name))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord.member) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.member.alias))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord.member) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.member.mobile))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord.member_loan_plan) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.emiDate))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.emiNo))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.arrear))]) : _vm._e()]), _vm._v(" "), _c('td', [(rowsAgentMemberRecord) ? _c('span', [_vm._v(_vm._s(rowsAgentMemberRecord.total))]) : _vm._e()]), _vm._v(" "), _c('td')])
  }), 0) : _vm._e()])])])])])]), _vm._v(" "), _vm._m(10)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('span', {
    staticClass: "pull-right"
  }), _vm._v(" "), _c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Member Collection")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Amount "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Payment Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Attendance "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Customer Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                CREATE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Sr No.")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Mem Code")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Member")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("(C/O) ALIAS")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Mob No")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Loan No")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("EMI Date")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("EMI No")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Curr Due")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("EMI")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Collection Amt")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                CREATE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75cb04b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Collection/GroupEMICollection.vue
// module id = 904
// module chunks = 0